import { RecordFormService, RecordFormValues } from './recordFormInterface';
import { zodResolver } from '@hookform/resolvers/zod';
import { createRecordFormZodSchema } from './recordFormSchema';
import { useForm } from 'react-hook-form';
import { useMemo } from 'react';
import { buildDefaultFormValues } from './recordFormFactory';
import { RecordFormServiceProps } from './recordFormProps';

export function createRecordFormService(): RecordFormService {
    return {
        useProps(context, item): RecordFormServiceProps {
            const schema = useMemo(
                () =>
                    createRecordFormZodSchema({
                        collection: item.collection,
                    }),
                [item.collection]
            );

            const form = useForm<RecordFormValues>({
                defaultValues: useMemo(
                    () =>
                        buildDefaultFormValues({
                            collection: item.collection,
                            record: item.record,
                        }),
                    [item.collection, item.record]
                ),
                resolver: zodResolver(schema),
                reValidateMode: 'onChange',
            });

            return {
                form,
                fields: {
                    title: {
                        value: form.watch('title') ?? null,
                        onChange(value) {
                            form.setValue('title', value, { shouldDirty: true });
                        },
                    },
                    properties: {
                        value: form.watch('properties') ?? null,
                        onChange(value) {
                            form.setValue('properties', value ?? {}, {
                                shouldDirty: true,
                            });
                        },
                    },
                },
            };
        },
    };
}
